module.exports = __webpack_public_path__ + "img/7.8b53846e.svg";